export default [
    { value: 'ROLE_ADMIN', label: 'Admin' },
    { value: 'ROLE_MANAGER', label: 'Manager' }
    // { value: 'ROLE_VENUE', label: 'Venue' }
]
